import GameFactory from "../../vendor_core/src/factories/GameFactory";
import BURCascadeReelGroup from "./view/BURCascadeReelGroup";
import BURWinSymbolsView from "./view/BURWinSymbolsView";
import BaseUI from "../../vendor_core/core/src/ui/BaseUI";
import BURReelSymbol from "./view/BURReelSymbol";
import BURWinBannerView from "./view/BURWinBannerView";
import UIDesktop from "../../vendor_core/src/base/ui/UIDesktop";
import Reel from "../../vendor_core/core/src/views/Reel";
import BURReelCascadeBehaviour from "./spinner/BURReelCascadeBehaviour";
import BaseSettings from "../../vendor_core/core/src/ui/BaseSettings";
import BURSettings from "./view/settings/BURSettings";
import BURPreloadView from "./view/BURPreloadView";

class BURGameFactory extends GameFactory {
    protected getWinSymbolsView() {
        return new BURWinSymbolsView();
    }

    protected getWinlinesView() {
        return new BURWinBannerView();
    }

    protected getReelGroup() {
        return new BURCascadeReelGroup();
    }

    protected getPreloadView() {
        return new BURPreloadView();
    }

    protected getSettings(): BaseSettings {
        return new BURSettings();
    }

    protected getUIView(): BaseUI {
        return new UIDesktop();
    }

    protected getSymbol() {
        return new BURReelSymbol();
    }
    protected getSpinBehaviour(params: {
        reel: Reel;
        sortFunction: any;
    }): BURReelCascadeBehaviour {
        return new BURReelCascadeBehaviour(params.reel, params.sortFunction);
    }
}

export default BURGameFactory;
